import styled from 'styled-components';

export const Title = styled.p`
  color: ${({ theme }) => theme.colors.black9};
  margin: 0;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  width: 100%;
`;
export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-items: center;
  padding-bottom: 16px;
  justify-content: space-between;
  width: 100%;
`;

export const BackButton = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 8px;

  border-radius: 4px;
`;
export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
